<template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="gray" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
      </template>
      <span>{{ message }}</span>
    </v-tooltip>
  </template>
  
  <script>
  export default {
    name: 'AutoFillTooltip',
    props: {
      message: {
        type: String,
        required: true
      }
    }
  }
  </script>